import { Box, Transition } from '@mantine/core';
import MarkdownEditor from 'src/common/components/markdown-editor/MarkdownEditor';
import SiestaActionBar from './SiestaActionBar';

type Props = {
  opened: boolean;
  editedContent: string;
  onApply: () => void;
  onDiscard: () => void;
};

export function EditPreviewSheet({ opened, editedContent, onApply, onDiscard }: Props) {
  return (
    <Transition mounted={opened} transition="slide-up" duration={300}>
      {styles => (
        <Box
          pos="absolute"
          top={80}
          left={0}
          right={0}
          bottom={0}
          bg="white"
          style={{
            ...styles,
            borderTopLeftRadius: 32,
            borderTopRightRadius: 32,
            borderBottomLeftRadius: 52,
            borderBottomRightRadius: 52,
            zIndex: 100,
            overflow: 'hidden',
            boxShadow: '-16px 0px 35px 0px rgba(0,0,0,0.1), -64px 0px 64px 0px rgba(0,0,0,0.09)',
          }}
        >
          <Box h="100%" style={{ overflow: 'auto' }} px="xxxxl" py="xxxl" pb={120}>
            <MarkdownEditor defaultValue={editedContent} bare readonly bg="white" />
          </Box>

          <Box pos="absolute" bottom={40} left={32} right={32} style={{ zIndex: 10 }}>
            <SiestaActionBar suggestions={[]} onApply={onApply} onDiscard={onDiscard} />
          </Box>
        </Box>
      )}
    </Transition>
  );
}
